import {
  useQuery,
  OperationVariables,
  DocumentNode,
  QueryHookOptions,
  QueryResult,
  TypedDocumentNode,
} from '@apollo/client';
import { deserialize } from '@enmon/commons';
import { useMemo } from 'react';

export const useStrapiQuery = <TData = unknown, TVariables extends OperationVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: QueryHookOptions<TData, TVariables>,
): QueryResult<TData, TVariables> => {
  const onCompleted = (data: TData) => options?.onCompleted?.(deserialize(data));

  const { data, ...rest } = useQuery<TData, TVariables>(query, { ...options, onCompleted });

  return {
    data: useMemo(() => deserialize(data), [data]),
    ...rest,
  };
};
